import { useLanguage } from '../contexts/LanguageContext';
import { Code2, Palette, Gauge, Cloud } from 'lucide-react';

export const ServicesSection = () => {
  const { t } = useLanguage();

  const services = [
    {
      icon: Code2,
      titleKey: 'service1Title',
      descKey: 'service1Desc',
    },
    {
      icon: Palette,
      titleKey: 'service2Title',
      descKey: 'service2Desc',
    },
    {
      icon: Gauge,
      titleKey: 'service3Title',
      descKey: 'service3Desc',
    },
    {
      icon: Cloud,
      titleKey: 'service4Title',
      descKey: 'service4Desc',
    },
  ];

  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-secondary/30"
    >
      <div className="max-w-7xl mx-auto">
        {/* Section title */}
        <h2
          data-testid="services-title"
          className="text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground mb-16 fade-in-up"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          {t('servicesTitle')}
        </h2>

        {/* Services grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {services.map((service, index) => (
            <div
              key={service.titleKey}
              data-testid={`service-card-${index + 1}`}
              className={`group glass-card p-8 md:p-10 rounded-2xl cursor-pointer fade-in-up stagger-${index + 1}`}
            >
              <div className="flex items-start gap-6">
                <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 transition-colors">
                  <service.icon className="w-8 h-8 text-primary" />
                </div>
                <div>
                  <h3
                    className="text-xl md:text-2xl font-semibold text-foreground mb-3 group-hover:text-primary transition-colors"
                    style={{ fontFamily: 'Outfit, sans-serif' }}
                  >
                    {t(service.titleKey)}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {t(service.descKey)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
